<mat-card appearance="outlined" class="mat-elevation-z1 mat-card-scrollable">
    @if (!isLoading) {
        <mat-card-header>
            <mat-card-title class="m-0">
                @if (currentMeeting.isOrdinary) {
                    {{ 'GeneralMeeting.OrdinaryAnnualMeeting' | translate }}
                } @else {
                    {{ 'GeneralMeeting.ExtraordinaryGeneralMeeting' | translate }}
                }
            </mat-card-title>
            <div class="ml-auto d-flex align-items-center">
                <button mat-icon-button (click)="showQrCode()" slHideIfDashboardEditMode>
                    <mat-icon>qr_code</mat-icon>
                </button>
                <button mat-icon-button (click)="openEditDialog()" slHideIfDashboardEditMode>
                    <mat-icon>edit</mat-icon>
                </button>
            </div>
        </mat-card-header>
        <mat-card-content class="container">
            <div class="block">
                <div class="heading">
                    {{ currentMeeting.companyName }}
                </div>
            </div>
            <div class="block">
                <div class="data">
                    {{ currentMeeting.startDateTime | localizedDate: 'fullDate' }}
                </div>
            </div>
            <div class="block">
                <div class="row no-gutters">
                    <div class="col-6">
                        {{ 'GeneralMeeting.Start' | translate }}
                    </div>
                    <div class="col-6">
                        {{ 'GeneralMeeting.DoorOpening' | translate }}
                    </div>
                </div>
                <div class="row no-gutters data">
                    <div class="col-6">
                        {{ currentMeeting.startDateTime | localizedDate: 'shortTime' }}
                    </div>
                    <div class="col-6">
                        {{ currentMeeting.doorOpening | localizedDate: 'shortTime' }}
                    </div>
                </div>
            </div>
            <div class="block">
                <div>{{ 'GeneralMeeting.Place' | translate }}</div>
                <div class="data">{{ currentMeeting.place }}</div>
            </div>
        </mat-card-content>
    } @else {
        {{ 'General.Loading' | translate }}...
    }
</mat-card>
